import { TDropItem } from 'src/types';

export const primaryTeachOptions: TDropItem[] = [
  { value: 'teachOnSite', label: 'On-site during the day' },
  { value: 'teachOnline', label: 'On-line' },
  { value: 'teachEvening', label: 'On-site during the evening' },
  { value: 'teachHome', label: 'Independent/Home School' },
  { value: 'teachOther', label: 'Other' },
];
